module.exports = __webpack_public_path__ + "img/facebook-footer.955acd5b.svg";